import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Divider,
  makeStyles
} from "@fluentui/react-components";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  accordionPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px"
  },
  accordionRow: {
    display: "flex",
    minHeight: "var(--lineHeightBase600, 32px)",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch"
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  lastAccordionItem: {
    marginBottom: "10px"
  }
});

export function VerseSettings({
  moderationChildren,
  resourceLimitsChildren,
  streamingChildren,
  accessChildren,
  detailsChildren,
  advancedChildren
}) {
  const intl = useIntl();
  const styles = useStyles();

  return (
    <div>
      <Accordion collapsible multiple defaultOpenItems={["1", "2", "3", "4", "5"]}>
        {detailsChildren && (
          <>
            <AccordionItem value="1">
              <AccordionHeader>
                <div className={styles.accordionHeader}>
                  <FormattedMessage id="room-settings-sidebar.details-settings" defaultMessage="Details" />
                </div>
              </AccordionHeader>
              <AccordionPanel className={styles.accordionPanel}>{detailsChildren}</AccordionPanel>
            </AccordionItem>
            <Divider />
          </>
        )}
        <AccordionItem value="2">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <FormattedMessage id="room-settings-sidebar.moderation-settings" defaultMessage="Moderation" />
            </div>
          </AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>{moderationChildren}</AccordionPanel>
        </AccordionItem>
        <Divider />
        {resourceLimitsChildren && (
          <>
            <AccordionItem value="3">
              <AccordionHeader>
                <div className={styles.accordionHeader}>
                  <FormattedMessage
                    id="room-settings-sidebar.resource-limits-settings"
                    defaultMessage="Capacity & resources"
                  />
                </div>
              </AccordionHeader>
              <AccordionPanel className={styles.accordionPanel}>{resourceLimitsChildren}</AccordionPanel>
            </AccordionItem>
            <Divider />
          </>
        )}
        {streamingChildren && (
          <>
            <AccordionItem value="4">
              <AccordionHeader>
                <div className={styles.accordionHeader}>
                  <FormattedMessage id="room-settings-sidebar.streaming-settings" defaultMessage="Streaming" />
                </div>
              </AccordionHeader>
              <AccordionPanel className={styles.accordionPanel}>{streamingChildren}</AccordionPanel>
            </AccordionItem>
            <Divider />
          </>
        )}
        <AccordionItem value="5">
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <span>
                {intl.formatMessage({
                  id: "room-settings-sidebar.access-settings",
                  defaultMessage: "Access"
                })}
              </span>
            </div>
          </AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>{accessChildren}</AccordionPanel>
        </AccordionItem>
        <Divider />
        <AccordionItem value="6" className={styles.lastAccordionItem}>
          <AccordionHeader>
            <div className={styles.accordionHeader}>
              <FormattedMessage id="room-settings-sidebar.advanced-settings" defaultMessage="Advanced Options" />
            </div>
          </AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>{advancedChildren}</AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

VerseSettings.propTypes = {
  moderationChildren: PropTypes.node,
  resourceLimitsChildren: PropTypes.node,
  streamingChildren: PropTypes.node,
  accessChildren: PropTypes.node,
  detailsChildren: PropTypes.node,
  advancedChildren: PropTypes.node
};
